/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Conversation } from '../../models/conversation';
import { ConversationWithOrganisationCreationData } from '../../models/conversation-with-organisation-creation-data';

export interface ConversationStartConversationWithOrganisation$Params {
      body: ConversationWithOrganisationCreationData
}

export function conversationStartConversationWithOrganisation(http: HttpClient, rootUrl: string, params: ConversationStartConversationWithOrganisation$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
  const rb = new RequestBuilder(rootUrl, conversationStartConversationWithOrganisation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Conversation>;
    })
  );
}

conversationStartConversationWithOrganisation.PATH = '/conversation/organisation';
